export default "__VITE_PUBLIC_ASSET__ab92f0cb__"